/* eslint-disable react/no-array-index-key */
import React, { FC, Fragment } from 'react';

type Props = {
  header?: string | null;
  content: JSX.Element[];
  actions?: JSX.Element[];
  type?: 'warning' | 'attention' | 'confirm' | 'information';
  classNames?: string[];
};

const AUNotificationComponent: FC<Props> = ({
  header = null,
  content,
  actions = [],
  type = 'information',
  classNames = [],
}) => {
  const typeClass = type === 'information' ? '' : `notification--${type}`;
  return (
    <div className={[
      'notification',
      typeClass,
    ].concat(classNames || []).join(' ').replace(/\s+/g, ' ').trim()}
    >
      <div className="notification__content">
        {
          header && <h2 className="notification__header">{header}</h2>
        }
        {content.map((c, i) => <Fragment key={i}>{c}</Fragment>)}
      </div>
      {
        (actions || []).length > 0 && (
          <div className="notification__actions">
            {(actions || []).map((a, i) => <Fragment key={i}>{a}</Fragment>)}
          </div>
        )
      }
    </div>
  );
};

AUNotificationComponent.displayName = 'AUNotificationComponent';
export default AUNotificationComponent;
